import type {
  FilterExternalModelReferencesRequest,
  FilterExternalModelReferencesResponse,
} from '@blk/aladdin-graph-client-axios-internal/wealth/integrations/partners/models/v1/external_model_reference_api';
import { awIntegrationsApi } from './Base';

export function getExternalModels(payload: FilterExternalModelReferencesRequest) {
  const path = '/partners/models/v1/externalModelReferences:filter';
  return awIntegrationsApi.post<FilterExternalModelReferencesResponse>(path, payload);
}
